import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {AlgemeneMelding} from '../algemene-melding';
import {DialogService} from '../../core/dialog/dialog.service';
import {filter} from 'rxjs/operators';
import User from '../../core/auth/user';
import {AlgemeneMeldingInputComponent} from '../algemene-melding-input/algemene-melding-input.component';
import {AlgemeneMeldingInput} from '../algemene-melding-input/algemene-melding-input';

@Component({
    selector: 'zah-algemene-meldingen',
    templateUrl: './algemene-meldingen.component.html',
    styleUrls: ['./algemene-meldingen.component.scss'],
    standalone: false
})
export class AlgemeneMeldingenComponent {
  private dialogService = inject(DialogService);

  @Input()
  algemeneMeldingen: Array<AlgemeneMelding>;
  @Input()
  user: User;
  @Output()
  algemeneMeldingAdded: EventEmitter<[string, string, string]> = new EventEmitter<[string, string, string]>();
  @Output()
  algemeneMeldingEdited: EventEmitter<[AlgemeneMelding, string, string, string]> = new EventEmitter<[AlgemeneMelding, string, string, string]>();
  @Output()
  algemeneMeldingDeleted: EventEmitter<AlgemeneMelding> = new EventEmitter<AlgemeneMelding>();

  getAlgemeneMeldingId(index: number, algemeneMelding: AlgemeneMelding): string {
    return algemeneMelding.getId();
  }

  canManageAlgemeneMeldingen(): boolean {
    return this.user.isRegioverantwoordelijke();
  }

  onMeldingClick(algemeneMelding: AlgemeneMelding): void {
    this.dialogService.showInformation(algemeneMelding.getContent());
  }

  onEditClick(algemeneMelding: AlgemeneMelding): void {
    this.dialogService.askDialog<AlgemeneMeldingInput>(AlgemeneMeldingInputComponent, algemeneMelding)
      .subscribe(algemeneMeldingInput => this.algemeneMeldingEdited.emit(
        [
          algemeneMelding,
          algemeneMeldingInput.content,
          algemeneMeldingInput.actiefVanDag,
          algemeneMeldingInput.actiefTotDag
        ]
      ));
  }

  onDeleteClick(algemeneMelding: AlgemeneMelding): void {
    this.dialogService
      .askConfirmation({message: 'Ben je zeker dat je de melding wil verwijderen?'})
      .pipe(filter(confirmation => confirmation))
      .subscribe(() => this.algemeneMeldingDeleted.emit(algemeneMelding));
  }

  onAddClick(): void {
    this.dialogService.askDialog<AlgemeneMeldingInput>(AlgemeneMeldingInputComponent)
      .subscribe(algemeneMeldingInput => this.algemeneMeldingAdded.emit(
        [
          algemeneMeldingInput.content,
          algemeneMeldingInput.actiefVanDag,
          algemeneMeldingInput.actiefTotDag
        ]
      ));
  }
}
